module.exports = [{"년도":2011,"종류":"신선식품지수","지수":6.3},{"년도":2012,"종류":"신선식품지수","지수":5.9},{"년도":2013,"종류":"신선식품지수","지수":-1.3},{"년도":2014,"종류":"신선식품지수","지수":-9.3},{"년도":2015,"종류":"신선식품지수","지수":2.1},{"년도":2016,"종류":"신선식품지수","지수":6.5},{"년도":2011,"종류":"농산물및석유류제외지수","지수":3.2},{"년도":2012,"종류":"농산물및석유류제외지수","지수":1.7},{"년도":2013,"종류":"농산물및석유류제외지수","지수":1.6},{"년도":2014,"종류":"농산물및석유류제외지수","지수":2},{"년도":2015,"종류":"농산물및석유류제외지수","지수":2.2},{"년도":2016,"종류":"농산물및석유류제외지수","지수":1.6}]


//////////////////
// WEBPACK FOOTER
// ./js/examples/data/consumer_price.json
// module id = 236
// module chunks = 6 19 29